import React, { useEffect, useState } from 'react';
import useToken from 'hooks/useToken';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { Card, Spinner, Col, Row } from 'react-bootstrap';

import ItemsPorVendedor from './ItemsPorVendedor'
import ErrorBoundary from 'components/common/ErrorBoundary';
import { useToast } from 'context/providers/ToastProvider';



const ItemGrafica = () => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [cargando, setCargando] = useState(true);

    const [chartData, setChartData] = useState({});

    useEffect(
        () => {
            obtenerVentasTotalesByVendedor_ITEMS();
        }
        , []);

    /**
     * Obtiene las ventas por vendedor en ITEMS
     */
    const obtenerVentasTotalesByVendedor_ITEMS = async () => {

        setCargando(true);
        const response = await fetch("/api/home/ITEMSVendidos",
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

                console.log('Hubo un problema con la peticion Fetch:' + error);
                setCargando(false);
            });

        if (response.ok) {
            const responseType = await response.json();
            //console.log(responseType);

            if (responseType.iResponseType == 1) {

                const data = JSON.parse(responseType.detalles);
                console.log("============= VENTAS POR VENDEDORES =================");
                console.log("data original:", data);
                console.log("data[0] (VentasPorVendedor):", data[0]);
                console.log("data[1] (Vendedores):", data[1]);
                console.log("data[2] (PromediosVendedores):", data[2]);

                const chartData_ = {
                    VentasPorVendedor: data[0],
                    Vendedores: data[1],
                };
                setChartData(chartData_);

                setCargando(false);
            } else {
                showErrorToast(responseType.vMessage);
                setCargando(false);
            }

            setCargando(false);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
            setCargando(false);
        }
    }



    return (
        <>
            {
                cargando ?
                    <>
                        <Card >
                            <Card.Header>
                                <Row>
                                    <Col>
                                        <h5><Spinner className='text-inline mt-3 ms-2' animation='border' variant='primary' /> Cargando... Ventas por vendedor </h5>
                                    </Col>

                                </Row>


                            </Card.Header>

                        </Card>
                        <Skeleton height={200} style={{ "zIndex": "-1" }} />
                    </>
                    :
                    <>
                        <Row>
                            <Col className="col-12">
                                <Card className="h-100">
                                    <Card.Header className="pb-2">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            📊 Items Vendidos por Vendedor
                                        </h6>
                                    </Card.Header>
                                    <Card.Body className="p-3">
                                        {/*<ItemChart*/}
                                        {/*    chartData={chartData}*/}
                                        {/*/>*/}
                                        <ErrorBoundary>
                                            <ItemsPorVendedor

                                                ventasPorVendedor={chartData.VentasPorVendedor}
                                                vendedores={chartData.Vendedores}

                                            />
                                        </ErrorBoundary>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </>
            }
        </>

    );
};

export default ItemGrafica;
